import { Task } from 'app/models';
import { FileType } from 'app/models/enums';
import { DownloadService, HttpService } from 'app/services';
import { ExportTaskBase } from 'app/shared/export/exportTaskBase';

export abstract class DownloadExportTaskBase extends ExportTaskBase {
  public isDownloading = () => this.downloadService.isDownloading;
  public setDownloading = (downloading: boolean) => (this.downloadService.isDownloading = downloading);

  constructor(httpService: HttpService, downloadService: DownloadService) {
    super(httpService, downloadService);
  }

  protected onTaskFinished(task: Task) {
    this.setDownloading(false);
    this.downloadService.downloadFile(task);
  }

  protected onTaskCheckError() {
    this.setDownloading(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/export/downloadExportTaskBase.ts